export default {
      id: "eye-usage",
      viewBox: "0 0 18 14",
      url: __webpack_public_path__ + "img/icons.31feac93.svg#eye",
      toString: function () {
        return this.url;
      }
    }